import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { reportingYear } from "../../../constants";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";
import ShareOfUsersVsCostChart from "./ShareOfUsersVsCostChart";

const ShareOfUsersVsCostChartWidget = props => {
  const [methodId, setMethodId] = useState();

  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="share_of_users_vs_cost_chart"
      reference="Figure 4.5"
      title={`Share of Users versus Cost, ${reportingYear}`}
      subtitle="Comparison by GNI Group"
      contentWidth={300}
      filters={[
        <MethodChooser
          id="figure-4-5"
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: "theme4.shareOfUsersVsCostChart",
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      chartRef={ref}
      chartSettings={{
        method: methodId ? props.database.methods[methodId] : "All"
      }}
    >
      <ShareOfUsersVsCostChart ref={ref} data={props.data} />
    </DataViewerFrame>
  );
};

ShareOfUsersVsCostChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ShareOfUsersVsCostChartWidget;
